module.exports = __webpack_public_path__ + "img/home.32e8e5e0.svg";